var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.5 47.5",
    style: {
      enableBackground: "new 0 0 47.5 47.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC107;}\n\t.st1{fill:#262D34;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.6,45c-2.3,0-3.3-1.7-2.3-3.7L21.8,3.7c1.1-2,2.8-2,3.9,0l19.5,37.6c1.1,2,0,3.7-2.3,3.7H4.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,18.5c0-1.1,0.8-1.7,1.8-1.7c1,0,1.8,0.7,1.8,1.7v9.9c0,1.1-0.8,1.7-1.8,1.7c-1.1,0-1.8-0.7-1.8-1.7V18.5z  M21.8,33.6c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2S21.8,34.7,21.8,33.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.cb7c93f78feac1cbca9829e05aaeff5b.svg";
export { ForwardRef as ReactComponent };